module.exports = __webpack_public_path__ + "img/young-m2c.fc0d5576.png";